import { atom } from 'jotai'

import { getLocaleFromUrl } from './locale-utils'
import type { Locale } from './types'

export const localeState = atom<Locale>(getLocaleFromUrl())
